import { isCometMcpSourceType } from '#pplx/frontend/apps/ask/sources/types/cometMcpSourceTypes.js';
import { isSourceType } from '#pplx/frontend/components/utils/SourcesConfig.js';
export function isAvailableSourceType(sourceType) {
    return isSourceType(sourceType) || isCometMcpSourceType(sourceType);
}
//# sourceMappingURL=availableSources.js.map